// Market-aware option sets for Cara's intake questions (used by ChatbotPage and
// the LP results questionnaire). India (or unresolved market) returns the EXACT
// legacy strings — byte-identical, so existing flows and stored answers are
// untouched. Tier-1 markets get region-neutral labels.
//
// CRITICAL: scoring_engine.resolve_company_key() maps the target_company ANSWER
// TEXT to a scoring profile by keyword — "big"/"mnc" → mnc, "startup" → startup,
// "small"/"medium"/"agenc" → smb, "remote"/"foreign"/"dollar" → remote. Every
// label below (both markets) MUST keep its trigger keyword, or scoring silently
// degrades to the "general" profile.

const COMPANY_OPTIONS_IN = [
  "Big MNCs (TCS, Infosys, Google, Amazon)",
  "Indian Startups (Zomato, Swiggy, Paytm)",
  "Small/Medium Companies (Local firms/Agencies)",
  "Remote Foreign Jobs (Earning in Dollars)",
];

const COMPANY_OPTIONS_T1 = [
  "Big Tech / Large Companies (Google, Amazon, Microsoft)", // "big" -> mnc
  "Startups (early-stage, high growth)",                    // "startup" -> startup
  "Small/Medium Companies (Local firms/Agencies)",          // "small/medium" -> smb
  "Remote-first Companies (work from anywhere)",            // "remote" -> remote
];

const JOINING_OPTIONS_IN = [
  "Immediately (Already on notice/Not working)",
  "Within 1 month (Quick joiner)",
  "2 to 3 months (Standard notice period)",
  "Just exploring (No hurry to join)",
];

// Notice-period conventions differ per market: US/CA ~2 weeks, UK commonly
// 1 month (often more), AU 2-4 weeks, India 60-90 days. joining_time is never
// parsed by the backend (analytics/report context only), so labels are free.
const JOINING_OPTIONS_US_CA = [
  "Immediately (not currently working / on notice)",
  "Within 2 weeks (standard notice)",
  "Within 1-2 months",
  "Just exploring (no hurry to join)",
];

const JOINING_OPTIONS_UK = [
  "Immediately (not currently working / on notice)",
  "Within 1 month (standard notice)",
  "1 to 3 months (longer notice)",
  "Just exploring (no hurry to join)",
];

const JOINING_OPTIONS_AU = [
  "Immediately (not currently working / on notice)",
  "Within 2-4 weeks (standard notice)",
  "1 to 2 months",
  "Just exploring (no hurry to join)",
];

const isIndia = (market) => !market || market === "IN";

export const companyOptions = (market) =>
  isIndia(market) ? COMPANY_OPTIONS_IN : COMPANY_OPTIONS_T1;

export const joiningOptions = (market) => {
  if (isIndia(market)) return JOINING_OPTIONS_IN;
  if (market === "UK") return JOINING_OPTIONS_UK;
  if (market === "AU") return JOINING_OPTIONS_AU;
  return JOINING_OPTIONS_US_CA;
};
